import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Header } from "../../Shared";
import { Subjects } from "../../../helper/constants.js";
import { Container, Row, Col } from "react-bootstrap";

import "../../../assets/stlyes/BigPicture/CurriculumCoverage.scss";
import { CurriculumAccordion } from "./CurriculumAccordion.js";

const CurriculumCoverage = () => {
  const [subjects, setSubjects] = useState([
    { subject: Subjects.Maths, isChecked: true },
    { subject: Subjects.Reading, isChecked: true },
    { subject: Subjects.Writing, isChecked: true },
    { subject: Subjects.Science, isChecked: true },
    { subject: Subjects.PE, isChecked: true },
  ]);
  const isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed)

  return (
    <>
      <div className="Page-layout">
        <div className="Page-header">
          <Header />
          <div className="Page-body margin">
            <div className="heading-curriculum">
              <div className="_heading-1">Curriculum Coverage</div>
              <div className="_heading-2">
                How much of the curriculum has been covered?
              </div>
            </div>
            <div className="containerMain _container">
              <Container className="_container" style={{ marginRight: isNavCollapsed ? "0px" : "" }}>
                <Row className="_container">
                  <Col md={12} className="_container">
                    <div className="_accordianContainer" >
                      <CurriculumAccordion subjects={subjects} setSubjects={setSubjects} />
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { CurriculumCoverage };
